import React, { useState, useEffect } from 'react';
import Chatbot from './Chatbot';
import logo from '../data/newlogo.png';
import whatsappIcon from '../data/wassup.png';
import instaIcon from '../data/insta.png';

const FAQ = [
  { q: 'How long does delivery take?', a: 'We deliver in 15–45 minutes within 6 km, and 35–120 minutes for 6–12 km locations.' },
  { q: 'What is the minimum order value?', a: 'Minimum order is ₹149. Free delivery on orders ₹149 and above. A ₹20 delivery fee applies below ₹149.' },
  { q: 'What payment methods are accepted?', a: 'We accept Cash on Delivery (COD) and UPI at the time of delivery. No advance online payment needed.' },
  { q: 'Can I cancel or modify my order?', a: 'Orders can be cancelled before they are confirmed. Once confirmed, please contact us immediately via WhatsApp chat.' },
  { q: 'What if I receive a wrong or damaged item?', a: 'Contact us on WhatsApp with your order ID and photos. We\'ll resolve it within 24 hours.' },
  { q: 'Do you accept returns?', a: 'We don\'t accept returns, but if you receive a damaged or incorrect item we\'ll make it right — just reach out on WhatsApp.' },
];

function HelpPage({ onClose, onOpenChat, showChatbot, onCloseChat, userName, userPhone, onOpenOrders, onOpenAddresses, onLogout }) {
  const [isOpen, setIsOpen] = useState(false);
  const [openFaq, setOpenFaq] = useState(null);

  useEffect(() => {
    const hour = new Date().getHours();
    setIsOpen(hour >= 6 && hour < 22);
  }, []);

  if (showChatbot) {
    return <Chatbot isOpen={true} onClose={onCloseChat} />;
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100dvh', background: 'var(--bg-primary)', overflow: 'hidden' }}>

      {/* ── Header with Back Button ── */}
      <header className="header" style={{ boxShadow: 'var(--shadow-sm)', borderBottom: '1px solid var(--border-light)', zIndex: 10 }}>
        <div className="topbar">
          <div className="brand" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <button
              onClick={onClose}
              style={{
                background: 'none',
                border: 'none',
                fontSize: '24px',
                cursor: 'pointer',
                padding: '4px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                color: '#374151',
                transition: 'transform var(--transition-fast)',
              }}
              onMouseEnter={e => e.currentTarget.style.transform = 'translateX(-2px)'}
              onMouseLeave={e => e.currentTarget.style.transform = 'translateX(0)'}
            >
              ←
            </button>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <img src={logo} alt="Flash" className="logo-image" />
              <span className="logo">Support</span>
            </div>
          </div>
          
          {/* Live status pill */}
          <div style={{
            display: 'flex', alignItems: 'center', gap: '6px',
            background: isOpen
              ? 'linear-gradient(135deg, rgba(255, 244, 237, 0.95) 0%, rgba(255, 237, 213, 0.92) 55%, rgba(254, 240, 138, 0.9) 100%)'
              : 'linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)',
            border: `1.5px solid ${isOpen ? 'rgba(255, 107, 53, 0.2)' : 'var(--error-bg)'}`,
            borderRadius: 'var(--radius-full)', padding: '6px 12px',
            boxShadow: isOpen ? '0 6px 16px rgba(255, 107, 53, 0.12)' : '0 2px 8px rgba(239, 68, 68, 0.15)',
          }}>
            <span style={{
              width: '8px', height: '8px', borderRadius: '50%',
              background: isOpen ? '#ff6b35' : 'var(--error)',
              animation: isOpen ? 'livePulse 2s ease-in-out infinite' : 'none',
              boxShadow: isOpen ? '0 0 0 2px rgba(255, 107, 53, 0.18)' : 'none',
            }} />
            <span style={{ fontSize: '12px', fontWeight: '700', color: isOpen ? '#9a3412' : 'var(--error-dark)', letterSpacing: '0.3px' }}>
              {isOpen ? 'Open Now' : 'Closed'}
            </span>
          </div>
        </div>
      </header>

      {/* ── Scrollable body ── */}
      <div style={{ 
        flex: 1, 
        overflowY: 'auto', 
        WebkitOverflowScrolling: 'touch', 
        paddingBottom: 'calc(80px + var(--safe-area-bottom, 0px))',
        animation: 'fadeIn 0.3s ease-out',
      }}>

        {/* Hero Section - Enhanced */}
        <div style={{
          background: 'linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%)',
          padding: '40px 20px 44px',
          textAlign: 'center',
          position: 'relative',
          overflow: 'hidden',
          borderRadius: '0 0 32px 32px',
          margin: '0 12px 24px',
          boxShadow: '0 20px 40px rgba(255, 90, 31, 0.2)',
        }}>
          {/* Decorative background pattern */}
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            opacity: 0.12,
            background: 'radial-gradient(circle at 20% 50%, white 0%, transparent 50%), radial-gradient(circle at 80% 80%, white 0%, transparent 50%)',
          }} />
          
          <div style={{ position: 'relative', zIndex: 1 }}>
            <div style={{
              fontSize: '56px',
              marginBottom: '16px',
              filter: 'drop-shadow(0 4px 12px rgba(0,0,0,0.15))',
              animation: 'float 3s ease-in-out infinite',
            }}>💬</div>
            <h2 style={{
              margin: '0 0 10px',
              color: 'white',
              fontSize: '26px',
              fontWeight: '800',
              letterSpacing: '-0.6px',
              textShadow: '0 2px 8px rgba(0,0,0,0.15)',
            }}>
              How can we help you?
            </h2>
            <p style={{
              margin: '0 0 24px',
              color: 'rgba(255,255,255,0.92)',
              fontSize: '15px',
              lineHeight: '1.6',
              maxWidth: '420px',
              marginLeft: 'auto',
              marginRight: 'auto',
              fontWeight: '500',
            }}>
              Get instant support for delivery, payments, and orders
            </p>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
              {[
                { icon: '🚚', text: '15–45 min' },
                { icon: '💵', text: 'COD' },
                { icon: '📍', text: 'Gudalur' }
              ].map((chip, idx) => (
                <span key={chip.text} style={{
                  background: 'rgba(255,255,255,0.22)',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255,255,255,0.35)',
                  borderRadius: 'var(--radius-full)',
                  padding: '8px 16px',
                  fontSize: '13px',
                  fontWeight: '600',
                  color: 'white',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  animation: `slideUp 0.4s ease-out ${idx * 0.1}s backwards`,
                }}>
                  <span>{chip.icon}</span>
                  <span>{chip.text}</span>
                </span>
              ))}
            </div>
          </div>
        </div>

        <div style={{ padding: '0 20px 20px' }}>

          {/* ── Quick Actions Section ── */}
          <div style={{ marginBottom: '28px' }}>
            <h3 style={{
              margin: '0 0 16px',
              fontSize: '19px',
              fontWeight: '800',
              color: 'var(--text-primary)',
              letterSpacing: '-0.4px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}>
              <span style={{ fontSize: '20px' }}>⚡</span>
              Quick Support
            </h3>

            {/* Chat CTA - Primary Action */}
            <button
              onClick={onOpenChat}
              style={{
                width: '100%', textAlign: 'left', cursor: 'pointer',
                background: 'linear-gradient(135deg, rgba(255, 245, 237, 0.98) 0%, rgba(255, 237, 213, 0.96) 35%, rgba(254, 240, 138, 0.92) 100%)',
                border: '2px solid rgba(255, 107, 53, 0.2)',
                borderRadius: 'var(--radius-2xl)',
                padding: '20px',
                marginBottom: '16px',
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                position: 'relative',
                transition: 'all var(--transition-base)',
                boxShadow: 'var(--shadow-md), 0 0 0 0 rgba(255,107,53,0.2)',
              }}
              onMouseEnter={e => {
                e.currentTarget.style.transform = 'translateY(-3px)';
                e.currentTarget.style.boxShadow = 'var(--shadow-xl), 0 0 24px rgba(255,107,53,0.25)';
              }}
              onMouseLeave={e => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = 'var(--shadow-md), 0 0 0 0 rgba(255,107,53,0.2)';
              }}
              onTouchStart={e => e.currentTarget.style.transform = 'scale(0.98)'}
              onTouchEnd={e => e.currentTarget.style.transform = 'scale(1)'}
            >
              <div style={{
                width: '60px', height: '60px', borderRadius: 'var(--radius-xl)',
                background: 'linear-gradient(135deg, #ff8a5b 0%, #ff6b35 55%, #f59e0b 100%)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '30px', flexShrink: 0,
                boxShadow: '0 8px 20px rgba(255,107,53,0.3)',
              }}>💬</div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ fontSize: '18px', fontWeight: '700', color: '#9a3412', marginBottom: '5px' }}>Chat with us</div>
                <div style={{ fontSize: '14px', color: '#9a3412', opacity: 0.85, display: 'flex', alignItems: 'center', gap: '5px' }}>
                  <span>⚡</span>
                  <span>Replies in under 2 minutes</span>
                </div>
              </div>
              <div style={{
                background: 'linear-gradient(135deg, #fb923c 0%, #f97316 100%)',
                color: 'white',
                fontSize: '11px',
                fontWeight: '700',
                padding: '6px 12px',
                borderRadius: 'var(--radius-lg)',
                flexShrink: 0,
                letterSpacing: '0.4px',
                boxShadow: '0 2px 8px rgba(249, 115, 22, 0.3)',
              }}>FASTEST</div>
            </button>

            {/* Contact Methods Grid */}
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
              {/* WhatsApp */}
              <a
                href="https://wa.me/919123456789?text=Hi%20Flash%20Support%2C%20I%20need%20help%20with%20my%20order"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none' }}
              >
                <div style={{
                  background: 'var(--bg-surface)',
                  borderRadius: 'var(--radius-xl)',
                  padding: '18px 16px',
                  border: '2px solid var(--border-default)',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '12px',
                  transition: 'all var(--transition-base)',
                  boxShadow: 'var(--shadow-sm)',
                  height: '100%',
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.transform = 'translateY(-3px)';
                  e.currentTarget.style.boxShadow = 'var(--shadow-lg)';
                  e.currentTarget.style.borderColor = '#25d366';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'var(--shadow-sm)';
                  e.currentTarget.style.borderColor = 'var(--border-default)';
                }}
                >
                  <div style={{
                    width: '48px', height: '48px', borderRadius: 'var(--radius-lg)',
                    background: 'linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    boxShadow: '0 2px 8px rgba(37, 211, 102, 0.15)',
                  }}>
                    <img src={whatsappIcon} alt="WhatsApp" style={{ width: '26px', height: '26px' }} />
                  </div>
                  <div>
                    <div style={{ fontSize: '15px', fontWeight: '700', color: 'var(--text-primary)', marginBottom: '3px' }}>WhatsApp</div>
                    <div style={{ fontSize: '12px', color: 'var(--text-muted)', lineHeight: '1.4' }}>Instant replies</div>
                  </div>
                </div>
              </a>

              {/* Instagram */}
              <a
                href="https://www.instagram.com/flash.delivery.in"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: 'none' }}
              >
                <div style={{
                  background: 'var(--bg-surface)',
                  borderRadius: 'var(--radius-xl)',
                  padding: '18px 16px',
                  border: '2px solid var(--border-default)',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '12px',
                  transition: 'all var(--transition-base)',
                  boxShadow: 'var(--shadow-sm)',
                  height: '100%',
                }}
                onMouseEnter={e => {
                  e.currentTarget.style.transform = 'translateY(-3px)';
                  e.currentTarget.style.boxShadow = 'var(--shadow-lg)';
                  e.currentTarget.style.borderColor = '#e91e63';
                }}
                onMouseLeave={e => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = 'var(--shadow-sm)';
                  e.currentTarget.style.borderColor = 'var(--border-default)';
                }}
                >
                  <div style={{
                    width: '48px', height: '48px', borderRadius: 'var(--radius-lg)',
                    background: 'linear-gradient(135deg, #fce7f3, #fdf2f8)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    boxShadow: '0 2px 8px rgba(233, 30, 99, 0.12)',
                  }}>
                    <img src={instaIcon} alt="Instagram" style={{ width: '26px', height: '26px' }} />
                  </div>
                  <div>
                    <div style={{ fontSize: '15px', fontWeight: '700', color: 'var(--text-primary)', marginBottom: '3px' }}>Instagram</div>
                    <div style={{ fontSize: '12px', color: 'var(--text-muted)', lineHeight: '1.4' }}>Follow updates</div>
                  </div>
                </div>
              </a>
            </div>
          </div>

          {/* ── Support Hours Card ── */}
          <div style={{
            background: 'var(--bg-surface)',
            borderRadius: 'var(--radius-2xl)',
            padding: '20px',
            border: '2px solid var(--border-default)',
            marginBottom: '28px',
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            boxShadow: 'var(--shadow-sm)',
            transition: 'all var(--transition-base)',
          }}
          onMouseEnter={e => e.currentTarget.style.boxShadow = 'var(--shadow-md)'}
          onMouseLeave={e => e.currentTarget.style.boxShadow = 'var(--shadow-sm)'}
          >
            <div style={{
              width: '52px', height: '52px', borderRadius: 'var(--radius-xl)',
              background: 'linear-gradient(135deg, var(--warning-bg-light) 0%, var(--warning-bg) 100%)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: '26px',
              flexShrink: 0,
              boxShadow: '0 4px 12px rgba(245, 158, 11, 0.2)',
            }}>⏰</div>
            <div style={{ flex: 1 }}>
              <div style={{ fontSize: '16px', fontWeight: '700', color: 'var(--text-primary)', marginBottom: '5px' }}>Support hours</div>
              <div style={{ fontSize: '14px', color: 'var(--text-secondary)', fontWeight: '500' }}>Mon – Sun · 6:00 AM – 10:00 PM</div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0 }}>
              <span style={{
                width: '10px', height: '10px', borderRadius: '50%',
                background: isOpen ? 'var(--success)' : 'var(--error)',
                display: 'inline-block',
                boxShadow: isOpen ? '0 0 0 3px rgba(16, 185, 129, 0.2)' : '0 0 0 3px rgba(239, 68, 68, 0.2)',
                animation: isOpen ? 'pulse 2s ease-in-out infinite' : 'none',
              }} />
              <span style={{ fontSize: '14px', fontWeight: '700', color: isOpen ? 'var(--success-dark)' : 'var(--error-dark)' }}>
                {isOpen ? 'Open' : 'Closed'}
              </span>
            </div>
          </div>

          {/* ── FAQ Section ── */}
          <div style={{ marginBottom: '28px' }}>
            <h3 style={{
              margin: '0 0 16px',
              fontSize: '19px',
              fontWeight: '800',
              color: 'var(--text-primary)',
              letterSpacing: '-0.4px',
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
            }}>
              <span style={{ fontSize: '20px' }}>❓</span>
              Frequently Asked Questions
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
              {FAQ.map((item, i) => (
                <div
                  key={i}
                  style={{
                    background: 'var(--bg-surface)',
                    borderRadius: 'var(--radius-xl)',
                    border: `2px solid ${openFaq === i ? 'var(--primary)' : 'var(--border-default)'}`,
                    overflow: 'hidden',
                    transition: 'all var(--transition-base)',
                    boxShadow: openFaq === i ? 'var(--shadow-lg), 0 0 0 4px rgba(255, 107, 53, 0.1)' : 'var(--shadow-xs)',
                  }}
                >
                  <button
                    onClick={() => setOpenFaq(openFaq === i ? null : i)}
                    style={{
                      width: '100%',
                      background: openFaq === i ? 'var(--primary-bg)' : 'transparent',
                      border: 'none',
                      padding: '18px 20px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: '16px',
                      cursor: 'pointer',
                      textAlign: 'left',
                      transition: 'background var(--transition-fast)',
                    }}
                  >
                    <span style={{
                      fontSize: '15px',
                      fontWeight: '600',
                      color: openFaq === i ? 'var(--primary-dark)' : 'var(--text-primary)',
                      lineHeight: '1.5',
                      flex: 1,
                    }}>
                      {item.q}
                    </span>
                    <span style={{
                      fontSize: '22px',
                      color: 'var(--primary)',
                      flexShrink: 0,
                      transform: openFaq === i ? 'rotate(45deg)' : 'rotate(0deg)',
                      transition: 'transform var(--transition-base)',
                      lineHeight: 1,
                      fontWeight: '300',
                      width: '28px',
                      height: '28px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}>+</span>
                  </button>
                  {openFaq === i && (
                    <div style={{
                      padding: '0 20px 18px',
                      fontSize: '14px',
                      color: 'var(--text-secondary)',
                      lineHeight: '1.7',
                      borderTop: '1px solid var(--border-light)',
                      paddingTop: '16px',
                      animation: 'fadeIn 0.25s ease-out',
                    }}>
                      {item.a}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>

          {/* ── Footer Card ── */}
          <div style={{
            background: 'linear-gradient(135deg, var(--warning-bg-light) 0%, var(--warning-bg) 100%)',
            borderRadius: 'var(--radius-2xl)',
            padding: '24px 20px',
            border: '2px solid var(--warning-bg)',
            textAlign: 'center',
            boxShadow: 'var(--shadow-md)',
          }}>
            <div style={{ fontSize: '36px', marginBottom: '12px', filter: 'drop-shadow(0 2px 6px rgba(0,0,0,0.12))' }}>🏪</div>
            <p style={{
              margin: '0 0 12px',
              fontSize: '17px',
              fontWeight: '700',
              color: 'var(--warning-dark)',
              letterSpacing: '-0.3px',
            }}>
              Proudly serving Gudalur & nearby areas
            </p>
            <div style={{
              display: 'flex',
              gap: '14px',
              justifyContent: 'center',
              fontSize: '13px',
              color: 'var(--warning-dark)',
              flexWrap: 'wrap',
              fontWeight: '600',
            }}>
              <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <span>🏪</span>
                <span>Local stores</span>
              </span>
              <span style={{ opacity: 0.5 }}>·</span>
              <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <span>⚡</span>
                <span>Fast delivery</span>
              </span>
              <span style={{ opacity: 0.5 }}>·</span>
              <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <span>💵</span>
                <span>COD</span>
              </span>
            </div>
          </div>

        </div>
      </div>

      <style>{`
        @keyframes livePulse {
          0%, 100% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.5; transform: scale(1.3); }
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        @keyframes slideUp {
          from { 
            opacity: 0; 
            transform: translateY(10px); 
          }
          to { 
            opacity: 1; 
            transform: translateY(0); 
          }
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-8px); }
        }

        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: 0.6; }
        }
      `}</style>
    </div>
  );
}

export default HelpPage;

// Made with Bob
